import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import FeatureRoutes from './components/features/FeatureRoutes';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import NavbarComponent from './components/Navbar';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import IndustriesPage from './pages/IndustriesPage';
import ProductsPage from './pages/ProductsPage';
import ResourcesPage from './pages/ResourcesPage';
import ServicesPage from './pages/ServicesPage';

// Import specific product pages
import CRMSolutionsPage from './pages/products/CRMSolutionsPage';
import ERPSuitePage from './pages/products/ERPSuitePage';
import FinancialManagementPage from './pages/products/FinancialManagementPage';
import HRManagementPage from './pages/products/HRManagementPage';
import SCMPage from './pages/products/SCMPage';

// Import specific industry pages
import FinancePage from './pages/industries/FinancePage';
import HealthcarePage from './pages/industries/HealthcarePage';
import ManufacturingPage from './pages/industries/ManufacturingPage';
import PublicSectorPage from './pages/industries/PublicSectorPage';
import RetailPage from './pages/industries/RetailPage';

// Import specific service pages
import ConsultingPage from './pages/services/ConsultingPage';
import ImplementationPage from './pages/services/ImplementationPage';
import SupportPage from './pages/services/SupportPage';
import TrainingPage from './pages/services/TrainingPage';

function App() {
  return (
    <Router>
      <div className="App">
        <NavbarComponent />
        <Routes>  
          <Route path="/" element={<HomePage />} />
          <Route path="/features/*" element={<FeatureRoutes />} />
          
          {/* Product Routes */}
          {/* <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/erp" element={<ERPSuitePage />} />
          <Route path="/products/crm" element={<CRMSolutionsPage />} />
          <Route path="/products/hr" element={<HRManagementPage />} />
          <Route path="/products/finance" element={<FinancialManagementPage />} />
          <Route path="/products/scm" element={<SCMPage />} />
           */}
          {/* Industry Routes */}
          {/* <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/manufacturing" element={<ManufacturingPage />} />
          <Route path="/industries/retail" element={<RetailPage />} />
          <Route path="/industries/healthcare" element={<HealthcarePage />} />
          <Route path="/industries/finance" element={<FinancePage />} />
          <Route path="/industries/public" element={<PublicSectorPage />} /> */}
          
          {/* Service Routes */}
          {/* <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/consulting" element={<ConsultingPage />} />
          <Route path="/services/implementation" element={<ImplementationPage />} />
          <Route path="/services/support" element={<SupportPage />} />
          <Route path="/services/training" element={<TrainingPage />} /> */}
          
          {/* Other Routes */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
